import { render, staticRenderFns } from "./topBanner.vue?vue&type=template&id=2b616788&scoped=true&"
import script from "./topBanner.vue?vue&type=script&lang=js&"
export * from "./topBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b616788",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b616788')) {
      api.createRecord('2b616788', component.options)
    } else {
      api.reload('2b616788', component.options)
    }
    module.hot.accept("./topBanner.vue?vue&type=template&id=2b616788&scoped=true&", function () {
      api.rerender('2b616788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/xcxPos/home/child/topBanner.vue"
export default component.exports